import ThemeSwitch from './ThemeSwitch.js'

ThemeSwitch.register()
